<template>
	<div class="v-label">
		<slot/>
    <i class="ss-pc icon-clear" @click="$emit('remove')"/>
	</div>
</template>

<script>
export default {
  mounted() {
    this.$el.ons(this.$listeners);
  }
};
</script>

<style lang="less">
.v-label {
  margin: 2px;
  padding: 0px 8px;
  overflow: hidden;
  line-height: 24px;
  border-radius: 12px;
  display: inline-flex;
  border: 1px solid #cccccc;
  background-color: #ffffff;
  &[removable] {
    padding-right: 0px;
    > i {
      display: block;
    }
  }
  > i {
    display: none;
    cursor: pointer;
    margin: 0px 4px;
    font-size: 16px;
    color: #999999;
    &:hover {
      color: #f5222d;
    }
  }
}
</style>
